import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { useForm, Link, usePage } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function UsersEdit({ user }) {
  const { auth } = usePage().props
  const { data, setData, patch, processing, errors } = useForm({
    name: user.name,
    org_admin: user.org_admin,
  })

  function handleSubmit(e) {
    e.preventDefault()
    patch(`/users/${user.id}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg">
        <div className="mb-6">
          <Link href={`/users/${user.id}`} className="text-sm text-indigo-600 hover:underline">
            ← {user.name}
          </Link>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">Redigera användare</h1>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Namn" error={errors.name}>
              <input
                type="text"
                value={data.name}
                onChange={e => setData('name', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            {auth.user?.org_admin && (
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="org_admin"
                  checked={data.org_admin}
                  onChange={e => setData('org_admin', e.target.checked)}
                  className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <label htmlFor="org_admin" className="text-sm text-gray-700">
                  Organisationsadmin
                </label>
              </div>
            )}

            <div className="flex gap-3">
              <Button type="submit" disabled={processing}>
                {processing ? 'Sparar…' : 'Spara ändringar'}
              </Button>
              <Link href={`/users/${user.id}`}>
                <Button type="button" variant="secondary">Avbryt</Button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
